import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy `/admin/users/$userId` → `/users/$userId` */
export const Route = createFileRoute(
  '/_private/_route/_internal/admin/users/$userId',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { userId: params.userId },
      replace: true,
      to: '/users/$userId',
    });
  },
});
